import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import ViewAsset from "./view";
import EditAsset from "./edit";
import { Package } from "lucide-react";
import AssetManagement from ".";
import { MODULE_ASSET_MANAGEMENT } from "variables/modules";

const assetManagementRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Asset Management",
		basePath: "assets-management",
		paramName: "recordId", 
		mainComponent: <AssetManagement />,
	    layout: "/console",	   
	    icon: <Package className="icon-item" />,
	    subTitle:"Asset Management",
	    viewComponent: <ViewAsset />,
	    createComponent: <EditAsset />,
	    editComponent: <EditAsset />,
		level:3,
		moduleId: MODULE_ASSET_MANAGEMENT,
	})
]

export default assetManagementRoutes;